import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
/* Components */
import Card from "./card";
import useGlobalStore from "../../store/useGlobalStore";

const CardList = ({ cardsData }) => {
  const navigate = useNavigate();  
  const { 
    creditAnimate, 
    setCreditAnimate, 
    urlCase, 
    setUrlCase, 
    setCreditAnimateClear, 
    setUrlCaseClear 
  } = useGlobalStore();
  
  useEffect(() => {
    let timeoutId;
    if (creditAnimate) {
      timeoutId = setTimeout(() => {
        const urlAfterAnimation = urlCase;
        navigate(urlAfterAnimation);
        setCreditAnimateClear();
        setUrlCaseClear();
      }, 1000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [creditAnimate, navigate, urlCase, setCreditAnimateClear, setUrlCaseClear]);

  function click(url, cardId) {
    console.log(cardId)
    setUrlCase(url);
    setCreditAnimate(cardId);
    setTimeout(() => {
      setUrlCase(url);
    }, 10);
  };

  return (
    <div className={`cards-group${cardsData.length > 4 ? ' cards-start' : ''}`}>
      {cardsData.map((cardData, index) => (
        <Card key={index} {...cardData} onClick={() => click(cardsData[index].link, cardsData[index].id)} animating={creditAnimate === cardsData[index].id} disabled={cardsData[index].disabled}/>
      ))}
    </div>
  );
}

export default CardList;